import '../assets/content.css';
import { jsx as t } from "react/jsx-runtime";
import * as o from "@radix-ui/react-tooltip";
import p from "clsx";
const r = "_tooltip_content_1jpt8_3", a = {
  tooltip_content: r
}, d = (n) => {
  const { children: e, className: i, collisionPadding: s = 8, sideOffset: l = 8, ...c } = n;
  return /* @__PURE__ */ t(o.Portal, { children: /* @__PURE__ */ t(
    o.Content,
    {
      "data-testid": "tooltip-content",
      collisionPadding: s,
      sideOffset: l,
      className: p(a.tooltip_content, i),
      ...c,
      children: e
    }
  ) });
};
d.displayName = "Tooltip.Content";
export {
  d as Content
};
